import React from 'react';

const UserGroupDetailPage = () => {
    return (
        <div>
            <div className='flex justify-between items-center'>
                <h1 className='text-2xl font-bold'>User Group Details</h1>
            </div>
        </div>
    )
}

export default UserGroupDetailPage;